/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBalancesRequest} from '@cash-web/protos/squareup/cash/cashcustomergateway/api/v1/app.pb'
import {GetBalancesResponse} from '@cash-web/protos/squareup/cash/cashcustomergateway/api/v1/app.pb'


export const getCustomerGatewayBalances = (request: GetBalancesRequest, options?: CashRequestOptions) => post<GetBalancesRequest, GetBalancesResponse>("/cash-app/customergateway/v1/get-balances", request, {...options, rejectOnError: true })